import React from "react";

import Author from "author/components/Author/Author";
import Authorize from "components/Library/Authorize/Authorize";
import Events from "events/components/Events";
import SearchResults from "search/components/SearchResults";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import StoryPermalink from "dashboard/containers/StoryPermalink";
import SectionStream from "dashboard/containers/SectionStream";
import TagStream from "dashboard/containers/TagStream";
import NotFound from "dashboard/components/NotFound";

import { getStoriesStream } from "actions/storiesStream";
import { getNewsletter, populateSubscription } from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import asyncComponent from "utils/asyncComponent";
import {
  setSectionWithTag,
  getSection,
  setLastSeen,
} from "actions/navigation";
import { getAuthor } from "author/actions/author";

import { URL_ID_REGEXP } from "config/constants";

const oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
const storyPermalinkRoute = `/:slug([A-Za-z0-9-]+?-)?:id${URL_ID_REGEXP}.html`;
const newsletterPermalinkRoute = `/newsletters/:subscription([A-Za-z0-9-]+)?-:newsletter${URL_ID_REGEXP}.html`;

const AsyncAbout = asyncComponent(() => import("about/components/About/About"));
const AsyncLegal = asyncComponent(() => import("legal/components/Legal/Legal"));
const AsyncUserSettings = asyncComponent(() => import("users/components/UserSettings/UserSettings"));
const AsyncSavedStories = asyncComponent(() => import("users/components/SavedStories/SavedStories"));

// New Components
const AsyncSectionStream = asyncComponent(() => import("stream/containers/SectionStream"));
const AsyncTagStream = asyncComponent(() => import("stream/containers/TagStream"));
const AsyncPermalinkStream = asyncComponent(() => import("stream/containers/PermalinkStream"));
const AsyncAuthorStream = asyncComponent(() => import("stream/containers/AuthorStream"));


export const routes = [
  {
    path: "/",
    exact: true,
    render: (props) => { 
      if (STREAM_REFACTOR) {
        return <AsyncSectionStream {...props} slug="top" />;
      } else {
        return <SectionStream {...props} slug="top" />;
      }
    },
    fetchData: (req, match, dispatch) => {
      const featuredReturnId = req.cookies.lastSeen || "";

      return Promise.all([
        dispatch(getSection("top")),
        dispatch(setLastSeen(featuredReturnId)),
        dispatch(getStoriesStream({ stream: "top", featured_return_id: featuredReturnId })),
      ]);
    },
  },
  {
    path: "/authors/:username",
    exact: true,
    component: STREAM_REFACTOR ? AsyncAuthorStream : Author,
    fetchData: (req, match, dispatch) => dispatch(getAuthor(match.params.username)),
  },
  {
    path: "/authorize",
    exact: true,
    component: Authorize,
  },
  {
    path: "/results",
    exact: true,
    component: SearchResults,
  },
  {
    path: "/legal",
    exact: true,
    component: AsyncLegal,
  },
  {
    path: "/about",
    exact: true,
    component: AsyncAbout,
  },
  {
    path: "/events",
    exact: true,
    component: Events,
  },
  {
    path: "/newsletters",
    exact: true,
    component: Subscriptions,
  },
  {
    path: newsletterPermalinkRoute,
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch, context) => Promise.all([
      getRedirectPath(req, match.params.newsletter, context),
      dispatch(getNewsletter(match.params.newsletter)),
      dispatch(populateSubscription(match.params.subscription)),
    ]),
  },
  {
    path: "/newsletters/:subscription",
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch) => dispatch(populateSubscription(match.params.subscription)),
  },
  {
    path: "/users/settings",
    exact: true,
    component: AsyncUserSettings,
  },
  {
    path: "/users/saved-stories",
    exact: true,
    component: AsyncSavedStories,
  },
  {
    path: "/tag/:tag",
    exact: true,
    component: STREAM_REFACTOR ? AsyncTagStream : TagStream,
    fetchData: (req, match, dispatch) => dispatch(setSectionWithTag(match.params.tag)),
  },
  {
    path: storyPermalinkRoute,
    component: STREAM_REFACTOR ? AsyncPermalinkStream : StoryPermalink,
    fetchData: (req, match, dispatch, context) => {
      if (req.query.preview || req.query.revision) return Promise.resolve();
      return Promise.all([
        getRedirectPath(req, match.params.id, context),
        dispatch(getStoriesStream({ story: match.params.id, stream: req.query.stream })),
      ]);
    },
  },
  {
    path: oldPermalinkRoute,
    render: () => { null },
    fetchData: (req, match, dispatch, context) => getRedirectPath(req, match.params.id, context),
  },
  {
    path: "/community/:user",
    fetchData: (req, match, dispatch, context) => {
      context.status = 301;
      context.path = `/authors/${match.params.user}`;
      return Promise.resolve();
    },
  },
  {
    path: "/:section([a-zA-Z-]+)",
    render: (props) => { 
      if (STREAM_REFACTOR) {
        return <AsyncSectionStream {...props} slug={props.match.params.section} />;
      } else {
        return <SectionStream {...props} slug={props.match.params.section} />;
      }
    },
    fetchData: (req, match, dispatch) => {
      const featuredReturnId = req.cookies.lastSeen || "";

      return Promise.all([
        dispatch(getSection(match.params.section)),
        dispatch(setLastSeen(featuredReturnId)),
        dispatch(getStoriesStream({ stream: match.params.section, featured_return_id: featuredReturnId })),
      ]);
    },
    exact: true,
  },
  // 404 fallback route
  {
    path: "/*",
    render: ({ staticContext }) => {
      if (staticContext) staticContext.status = 404;
      return <NotFound />;
    },
  },
];
